import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const teamSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
});

// Action creators are generated for each case reducer function
// export const {} = teamSlice.actions;

export default teamSlice.reducer;
